var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoogleMapLoader',{attrs:{"map-config":_vm.mapConfig,"api-key":"AIzaSyCu8wi_ObsAmDZsoBsgoUQEMCI87b06NIU","get-position":_vm.getPosition},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var google = ref.google;
var map = ref.map;
return _vm._l((_vm.markers),function(marker){return _c('GoogleMapMarker',{key:marker.id,attrs:{"marker":marker,"google":google,"map":map,"info-window":_vm.infoWindow,"info-window-instance":_vm.infoWindowInstance}})})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }